/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TaglineInputs */

const en_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering Innovation, from concept to code. We design and build performant, scalable web experiences, turning ideas into production ready software.`)
};

const ar_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هندسة الابتكار، من الفكرة إلى الكود. نصمّم ونبني تجارب ويب عالية الأداء وقابلة للتوسع، ونحوّل الأفكار إلى برمجيات جاهزة للإنتاج.`)
};

const bn_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আইডিয়া থেকে কোড, ইঞ্জিনিয়ারিংয়ের নতুনত্ব। দ্রুত ও স্কেল করা যায় এমন ওয়েব অভিজ্ঞতা তৈরি করে আইডিয়াকে প্রোডাকশনের জন্য তৈরি সফটওয়্যারে রূপ দিই।`)
};

const de_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering-Innovation, vom Konzept bis zum Code. Wir entwickeln performante, skalierbare Web-Erlebnisse und machen aus Ideen produktionsreife Software.`)
};

const es_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innovación de ingeniería, del concepto al código. Diseñamos y construimos experiencias web rápidas y escalables, convirtiendo ideas en software listo para producción.`)
};

const fr_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’innovation par l’ingénierie, du concept au code. Nous concevons des expériences web rapides et évolutives, et transformons les idées en logiciels prêts pour la production.`)
};

const pt_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inovação em engenharia, do conceito ao código. Criamos experiências web rápidas e escaláveis, transformando ideias em software pronto para produção.`)
};

const zh_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工程创新，从概念到代码。我们设计和构建高性能、可扩展的网络体验，将想法转化为可生产的软件。`)
};

const tr_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konseptten koda Mühendislik Yeniliği. Performanslı, ölçeklenebilir web deneyimleri tasarlıyor ve oluşturuyoruz, fikirleri üretime hazır yazılımlara dönüştürüyoruz.`)
};

const ru_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инженерные инновации: от концепции до кода. Мы проектируем и создаем производительные, масштабируемые веб-интерфейсы, превращая идеи в готовое к использованию программное обеспечение.`)
};

const pl_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innowacje inżynieryjne, od koncepcji do kodu. Projektujemy i budujemy wydajne, skalowalne doświadczenia internetowe, przekształcając pomysły w oprogramowanie gotowe do produkcji.`)
};

/**
* | output |
* | --- |
* | "Engineering Innovation, from concept to code. We design and build performant, scalable web experiences, turning ideas into production ready software." |
*
* @param {Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_tagline = /** @type {((inputs?: Footer_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_footer_tagline(inputs)
	if (locale === "bn") return bn_footer_tagline(inputs)
	if (locale === "de") return de_footer_tagline(inputs)
	if (locale === "es") return es_footer_tagline(inputs)
	if (locale === "fr") return fr_footer_tagline(inputs)
	if (locale === "pt") return pt_footer_tagline(inputs)
	if (locale === "zh") return zh_footer_tagline(inputs)
	if (locale === "tr") return tr_footer_tagline(inputs)
	if (locale === "ru") return ru_footer_tagline(inputs)
	if (locale === "pl") return pl_footer_tagline(inputs)
	return en_footer_tagline(inputs)
});